import * as React from 'react';
const SvgHeadphones = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
        <path
            d="M9 2a7 7 0 00-7 7v1h2.08c.67 0 1 0 1.26.13.23.12.41.3.53.53.13.25.13.59.13 1.26v4.16c0 .67 0 1-.13 1.26-.12.23-.3.41-.53.53-.25.13-.59.13-1.26.13H3.2c-1.12 0-1.68 0-2.1-.22a2 2 0 01-.88-.87C.02 16.5 0 15.99 0 15V9a9 9 0 1118 0v6c0 .99-.01 1.5-.22 1.9a2 2 0 01-.87.88c-.43.22-.99.22-2.11.22h-.88c-.67 0-1 0-1.26-.13a1.2 1.2 0 01-.53-.53c-.13-.25-.13-.59-.13-1.26v-4.16c0-.67 0-1 .13-1.26.12-.23.3-.41.53-.53.25-.13.59-.13 1.26-.13H16V9a7 7 0 00-7-7z"
            fill="currentColor"
        />
    </svg>
);
export default SvgHeadphones;
